import * as tslib_1 from "tslib";
// Core packages
import { formatDate } from "@angular/common";
import { OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog } from "@angular/material";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { TranslateService } from "@ngx-translate/core";
import * as FileSaver from "file-saver";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { combineLatest, merge } from "rxjs";
import { debounceTime, distinctUntilChanged, finalize, startWith, take, tap } from "rxjs/operators";
// Custom packages
import { PlatformNotesService } from "src/app/components/platform-note-card/platformNotes.service";
import { AuthService } from "src/app/modules/auth/auth.service";
import { BalancesService } from "src/app/modules/balances/balances.service";
import { AddInvoiceDialogComponent } from "src/app/modules/balances/components/add-invoice-dialog/add-invoice-dialog.component";
import { EditInvoiceDialogComponent } from "src/app/modules/balances/components/edit-invoice-dialog/edit-invoice-dialog.component";
import { BalanceEditNoteDialogComponent } from 'src/app/modules/balances/components/edit-note-dialog/edit-note-dialog.component';
import { BalancePrintDetailDialogComponent } from 'src/app/modules/balances/components/print-detail-dialog/print-detail-dialog.component';
import { BalanceViewDetailDialogComponent } from 'src/app/modules/balances/components/view-detail-dialog/view-detail-dialog.component';
import { InvoicesService } from "src/app/modules/balances/invoices.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { ViewNotesDialogComponent } from "src/app/shared/components/dialogs/document-note-dialog/view-notes-dialog.component";
import { Balance } from "src/app/shared/models/balance/balance.model";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ListsService } from "src/app/shared/services/lists.service";
import { ThemeService } from "src/app/shared/services/theme.service";
import { InvoicesDataSource } from "src/app/shared/utils/data-sources/invoices-data-source";
;
var BalanceDetailComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function BalanceDetailComponent(configService, activatedRoute, balancesService, propertiesService, router, toastrService, helperService, translateService, themeService, authService, dialog, cookieService, companiesService, invoicesService, listsService, platformNotesService) {
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.balancesService = balancesService;
        this.propertiesService = propertiesService;
        this.router = router;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.dialog = dialog;
        this.cookieService = cookieService;
        this.companiesService = companiesService;
        this.invoicesService = invoicesService;
        this.listsService = listsService;
        this.platformNotesService = platformNotesService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.balance = new Balance();
        this.detailCardIsLoading = true;
        this.deleteCardIsLoading = true;
        // BEGIN - Table balances
        this.displayedColumns = ['index', "number", "date", "file", "actions"];
        // @ViewChild('input', { static: true }) input: ElementRef;
        this.numberFilter = new FormControl("");
        this.dateFilter = new FormControl("");
        this.fileFilter = new FormControl("");
        // END - Table balances
        // BEGIN - Add balance form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.notesField = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        // END - Add balance form
        this.deleteBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.delete"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "warn",
            spinnerColor: "warn",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-trash",
                inline: true,
            },
        };
        this.displayedTotal = 0;
        this.previousValue = {};
        this.availableOptions = [];
        this.notes = [];
        this.companyName = "";
        this.companyTaxCode = "";
        this.companyVatNumber = "";
        this.ownerName = "";
        this.ownerTaxCode = "";
        this.ownerVatNumber = "";
        this.propertyName = "";
        this.propertyTaxCode = "";
        this.invoiceHolder = "property";
        this.administrationEndDate = "";
        this.administrationStartDate = "";
        this.isThisFirstBalance = false;
        this.originalBalanceDetail = [];
        this.showInvoice = true;
        this.balanceNumber = 0;
        this.balanceDetailsView = '';
        this.propertyId = '';
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("balances.detail.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // Set pdf fonts
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        // Get requested balance data
        var balanceId = this.activatedRoute.snapshot.params.balanceId;
        this.subscriptions.push(this.balancesService.get(balanceId).subscribe(function (res) {
            if (res.status) {
                _this.propertyId = res.data.property._id;
                _this.loadBalanceData(res.data);
                _this.balanceNumber = res.data.number;
                _this.balanceDetailsView =
                    res.data.status !== 'open' &&
                        res.data.detailCopy &&
                        Array.isArray(res.data.detailCopy) &&
                        res.data.detailCopy.length;
                if (res.data.status && res.data.status === "closed") {
                    // Load first set of data
                    _this.loadInvoicesPage();
                    // Reset pagination after sorting
                    _this.subscriptions.push(_this.sort.sortChange.subscribe(function () { return (_this.paginator.pageIndex = 0); }));
                    // Once user change sorting OR change page
                    // let's reload the page data
                    _this.subscriptions.push(merge(_this.sort.sortChange, _this.paginator.page)
                        .pipe(tap(function () { return _this.loadInvoicesPage(); }))
                        .subscribe());
                    // Handle server-side filtering through column-specific search
                    // Why do we use "null as string"? --> @see https://github.com/ReactiveX/rxjs/issues/4772
                    _this.subscriptions.push(combineLatest([
                        _this.numberFilter.valueChanges.pipe(startWith(null)),
                        _this.dateFilter.valueChanges.pipe(startWith(null)),
                        _this.fileFilter.valueChanges.pipe(startWith(null)),
                    ])
                        .pipe(debounceTime(_this.configService.debounceTime), // max 1 query every 350 milliseconts
                    distinctUntilChanged() // Eliminate duplicate values
                    )
                        .subscribe(function (res) {
                        // Load page only if at least one value is not null
                        if (!res.every(function (value) { return value === null; })) {
                            _this.loadInvoicesPage();
                        }
                    }));
                }
                else {
                    _this.showInvoice = false;
                }
                return;
            }
            // Something bad happened
            // redirect user to balances list
            _this.router.navigate([_this.lang, "app", "balances", "list"]);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.helperService.handleError(err);
            _this.router.navigate([_this.lang, "errors", "404"]);
        }));
        // Init data source
        this.dataSource = new InvoicesDataSource(this.invoicesService, this.helperService);
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all balances
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle params change
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.loadBalanceData = function (balance) {
        var e_1, _a;
        var _this = this;
        // Set permission data
        this.balance.setData(balance);
        var currentNumber = 0;
        if (balance && balance.number) {
            currentNumber = balance.number;
        }
        var propertyId = balance.property && balance.property._id
            ? balance.property._id
            : undefined;
        if (propertyId) {
            this.subscriptions.push(this.balancesService
                .getList(0, 10, "createdAt", "asc", { propertyId: propertyId })
                .subscribe(function (res) {
                if (res.status) {
                    if (res.data.items &&
                        Array.isArray(res.data.items) &&
                        res.data.items.length > 0) {
                        var index = res.data.items.findIndex(function (el) {
                            return el.number === currentNumber;
                        });
                        if (index === 0) {
                            _this.isThisFirstBalance = true;
                        }
                        // Init edit form
                        _this.initForm();
                    }
                    return;
                }
            }, function (err) {
                // if we came here users with given userId do not exist
                // this.helperService.handleError(err);
            }));
        }
        // Set property id
        if (balance.status === "open") {
            this.subscription =
                balance.property && balance.property.subscription
                    ? balance.property.subscription
                    : undefined;
        }
        else {
            this.subscription = balance.subscription;
        }
        // Set companyId
        this.companyId =
            balance.property &&
                balance.property.admin &&
                balance.property.admin.company
                ? balance.property.admin.company
                : undefined;
        // Set company ownerId
        this.ownerId =
            balance.property && balance.property.owner
                ? balance.property.owner
                : undefined;
        this.propertyName =
            balance.property && balance.property.name ? balance.property.name : "";
        this.propertyTaxCode =
            balance.property && balance.property.taxCode
                ? balance.property.taxCode
                : "";
        this.invoiceHolder =
            balance.property && balance.subscription.invoiceHolder
                ? balance.subscription.invoiceHolder
                : "property";
        if (this.invoiceHolder === "property" || this.invoiceHolder === "admin") {
            this.subscriptions.push(this.companiesService.get(this.companyId).subscribe(function (res) {
                if (res && res.status && res.data) {
                    _this.companyName = res.data.name;
                    _this.companyTaxCode = res.data.taxCode
                        ? res.data.taxCode
                        : "";
                    _this.companyVatNumber = res.data.vatNumber
                        ? res.data.vatNumber
                        : "";
                }
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
        else if (this.invoiceHolder === "owner") {
            this.subscriptions.push(this.companiesService.get(this.ownerId).subscribe(function (res) {
                if (res && res.status && res.data) {
                    _this.ownerName = res.data.name;
                    _this.ownerTaxCode = res.data.taxCode
                        ? res.data.taxCode
                        : "";
                    _this.ownerVatNumber = res.data.vatNumber
                        ? res.data.vatNumber
                        : "";
                }
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
        if (balance.property.administrationEndDate &&
            moment(balance.property.administrationEndDate).isValid()) {
            this.administrationEndDate = moment(balance.property.administrationEndDate).format("DD/MM");
        }
        if (balance.property.administrationStartDate &&
            moment(balance.property.administrationStartDate).isValid()) {
            this.administrationStartDate = moment(balance.property.administrationStartDate).format("DD/MM");
        }
        // Set notes
        this.notes = [];
        if (balance.notes && Array.isArray(balance.notes)) {
            try {
                for (var _b = tslib_1.__values(balance.notes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    this.notes.push({
                        _id: item._id,
                        property: false,
                        category: item.category ? item.category : '',
                        createdBy: item.createdBy,
                        createdAt: item.createdAt,
                        title: item.title,
                        text: item.text,
                        file: item.file
                    });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (balance.status !== 'closed') {
            this.subscriptions.push(this.platformNotesService.getProperty(this.propertyId, 0, 100)
                .subscribe(function (res) {
                var e_2, _a;
                if (res.data.items && Array.isArray(res.data.items)) {
                    try {
                        for (var _b = tslib_1.__values(res.data.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var item = _c.value;
                            if (item.category === 'subscription' ||
                                item.category === 'work-account') {
                                _this.notes.push({
                                    property: true,
                                    category: item.category,
                                    createdBy: item.createdBy,
                                    createdAt: item.createdAt,
                                    title: item.title,
                                    text: item.description,
                                    file: item.file
                                });
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }));
        }
        // Stop loading in delete form
        this.deleteCardIsLoading = false;
        // // Init edit form
        // this.initForm();
        if (this.subscription && this.subscription.key) {
            // Get available code options
            this.getAvailableOptions(this.subscription.key);
        }
        // Init total value
        this.initTotal();
        // Make detail form card visible by disabling his card-spinner
        this.detailCardIsLoading = false;
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.initForm = function () {
        var _this = this;
        // Set model
        var balanceData = this.balance.getData();
        if (balanceData.detail && Array.isArray(balanceData.detail)) {
            this.originalBalanceDetail = balanceData.detail;
        }
        // Detail transformation (grouping for open accounts, consolidation of
        // scan/insert families for pending/closed accounts, special descriptions and
        // amounts) is now performed authoritatively by the backend on the status
        // transition (PATCH /balances/{id}). The FE renders the detail/detailCopy/total
        // returned by the server as-is and no longer transforms them client-side.
        this.model = balanceData;
        this.fields = [];
        this.notesField = [];
        // Set fields
        this.fields = [
            {
                className: "section-label mb-0",
                template: "<hr /><div><strong>" +
                    this.translateService.instant("balances.fields.detail.label") +
                    "</strong></div><br />",
            },
            {
                key: "detail",
                type: "repeat",
                fieldArray: {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                        {
                            className: "col-12 col-md-4 col-lg-2",
                            type: "input",
                            key: "code",
                            id: "111",
                            templateOptions: {
                                label: this.translateService.instant("balances.fields.detail.code"),
                                placeholder: this.translateService.instant("balances.fields.detail.code"),
                                disabled: true,
                            },
                        },
                        {
                            className: "col-12 col-md-4 col-lg-4",
                            type: "textarea",
                            key: "description",
                            templateOptions: {
                                label: this.translateService.instant("balances.fields.detail.description"),
                                placeholder: this.translateService.instant("balances.fields.detail.description"),
                            },
                            expressionProperties: {
                                "templateOptions.disabled": function () {
                                    return _this.model.status && _this.model.status === "closed";
                                },
                                "templateOptions.rows": function (model) {
                                    return model.description.length
                                        ? Math.ceil(model.description.length / 50)
                                        : 1; // 50 is the average char number in one line
                                },
                            },
                        },
                        {
                            className: "col-12 col-md-4 col-lg-1",
                            type: "input",
                            key: "quantity",
                            templateOptions: {
                                type: "number",
                                label: this.translateService.instant("balances.fields.detail.quantity"),
                                placeholder: this.translateService.instant("balances.fields.detail.quantity"),
                                min: 0,
                                required: true,
                            },
                            expressionProperties: {
                                "templateOptions.readonly": function () {
                                    return _this.model.status && _this.model.status === "closed";
                                },
                            },
                        },
                        {
                            className: "col-12 col-md-4 col-lg-2",
                            type: "input",
                            key: "unitPrice",
                            templateOptions: {
                                type: "number",
                                label: this.translateService.instant("balances.fields.detail.unitPrice"),
                                placeholder: this.translateService.instant("balances.fields.detail.unitPrice"),
                                min: 0,
                                required: true,
                            },
                            expressionProperties: {
                                "templateOptions.readonly": function () {
                                    return _this.model.status && _this.model.status === "closed";
                                },
                            },
                        },
                        {
                            className: "col-12 col-md-4 col-lg-2",
                            type: "input",
                            key: "totalRow",
                            templateOptions: {
                                type: "number",
                                label: this.translateService.instant("balances.fields.detail.totalRow"),
                                placeholder: this.translateService.instant("balances.fields.detail.totalRow"),
                                readonly: true,
                                min: 0,
                            },
                        },
                    ],
                },
                templateOptions: {
                    askConfirm: true,
                    status: this.model.status,
                    addWithDialog: true,
                    delBnt: true,
                },
                expressionProperties: {
                    "templateOptions.options": function () {
                        return _this.availableOptions;
                    },
                },
            },
            {
                className: "section-label",
                template: "<hr /><br />",
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-9",
                    },
                    {
                        className: "col-2",
                        type: "input",
                        key: "discount",
                        templateOptions: {
                            label: this.translateService.instant("balances.fields.discount"),
                            placeholder: this.translateService.instant("balances.fields.discount"),
                            required: true,
                            type: "number",
                            min: 0,
                            max: 1000,
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                _this.updateTotal(model);
                            },
                            "templateOptions.readonly": function () {
                                return _this.model.status && _this.model.status === "closed";
                            },
                        },
                    },
                ],
            },
        ];
        // Set notes field
        this.notesField = [
            {
                className: "section-label mb-0 mt-4",
                template: "<hr /><div><strong>" +
                    this.translateService.instant("balances.fields.newNote") +
                    "</strong></div>",
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        type: "textarea",
                        key: "notes.text",
                        templateOptions: {
                            rows: 5,
                            maxLength: 5000,
                        },
                        expressionProperties: {
                            "templateOptions.description": '(model[field.key]||"").length+"/" +field.templateOptions.maxLength',
                        },
                    },
                ],
            },
        ];
    };
    /**
     * Get available balance detail options
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.getAvailableOptions = function (code) {
        this.availableOptions = this.configService.availableAccessoriesCodes.filter(function (element) {
            return element.keys.includes(code);
        });
    };
    /**
     * Handle balance status change
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onStatusChange = function () {
        var _this = this;
        var status = this.model.status;
        var property = this.model.property;
        if (!status || !property) {
            return;
        }
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("balances.status.changeMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                // User hit decline button
                return;
            }
            var propertyNotes = _this.notes.filter(function (el) { return el.property; });
            // The backend now recomputes detail/detailCopy/total authoritatively on
            // the transition. The FE sends only the transition intent plus the data
            // the backend still needs: the starting status (must match the persisted
            // one for idempotency), the property (used to create the next open
            // balance) and the subscription snapshot. propertyNotes are merged by the
            // backend on pending->closed. detail/detailCopy/total are NOT sent.
            var balanceId = _this.balance.getId();
            _this.subscriptions.push(_this.balancesService
                .changeStatus(balanceId, {
                status: status,
                property: property,
                subscription: _this.subscription,
                propertyNotes: propertyNotes
            })
                .subscribe(function (res2) {
                if (res2.status) {
                    _this.toastrService.success(res2.message);
                    // Reload from the backend to reflect the recomputed
                    // detail/detailCopy/total/status (and the populated property).
                    _this.subscriptions.push(_this.balancesService.get(balanceId).subscribe(function (res) {
                        if (res.status) {
                            _this.loadBalanceData(res.data);
                        }
                    }, function (err) {
                        _this.helperService.handleError(err);
                    }));
                }
            }, function (err) {
                // Business errors (422 missing billing codes, 409 stale status,
                // 400 invalid transition) carry an explicit backend message.
                // Show it directly: the generic handleError would mis-render the
                // 422 payload (its `data` is not in the validation-error shape).
                if (err && err.error && err.error.message) {
                    _this.toastrService.error(err.error.message);
                }
                else {
                    _this.helperService.handleError(err);
                }
            }));
        });
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onFormSubmit = function () {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            return;
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        if (this.displayedTotal !== this.model.total) {
            this.model.total = this.displayedTotal;
        }
        if (typeof this.model.total === "undefined" || !this.model.total) {
            this.model.total = 0;
        }
        if (typeof this.model.detail === "undefined" || !this.model.detail) {
            this.model.detail = [];
        }
        var balanceData = this.balance.getData();
        if (balanceData.status === "closed") {
            this.model.detail = this.originalBalanceDetail;
        }
        // Handle balance notes
        var notes = [];
        if (this.model.notes.text) {
            if (this.balance.get('notes') && Array.isArray(this.balance.get('notes'))) {
                notes = JSON.parse(JSON.stringify(this.balance.get('notes')));
            }
            notes.push({
                text: this.model.notes.text,
                createdAt: moment().toISOString(),
                createdBy: this.loggedUser._id,
            });
            this.model.notes = notes;
        }
        this.subscriptions.push(this.balancesService
            .update(this.balance.getId(), this.model)
            .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
            .subscribe(function (res) {
            if (res.status) {
                var previousProperty = _this.balance.get("property");
                _this.balance.setData(res.data);
                _this.balance.set("property", previousProperty);
                _this.toastrService.success(res.message);
                // Get requested balance data
                var balanceId = _this.activatedRoute.snapshot.params.balanceId;
                _this.subscriptions.push(_this.balancesService.get(balanceId).subscribe(function (res) {
                    if (res.status) {
                        _this.loadBalanceData(res.data);
                        return;
                    }
                }, function (err) {
                    // if we came here users with given userId do not exist
                    _this.helperService.handleError(err);
                }));
            }
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Returns calculated total value
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.calculateTotal = function () {
        var _this = this;
        var total = 0;
        if (this.model.detail) {
            this.model.detail.forEach(function (element, index) {
                var detailControl = _this.form.controls.detail;
                var rowControl = detailControl
                    ? detailControl.controls[index]
                    : undefined;
                var totalRowControl = rowControl
                    ? rowControl.controls["totalRow"]
                    : undefined;
                var totalRow = element.quantity * element.unitPrice;
                if (totalRow !== element.totalRow) {
                    element.totalRow = totalRow;
                    if (totalRowControl) {
                        totalRowControl.setValue(totalRow);
                    }
                }
                total += totalRow;
            });
            return total;
        }
    };
    /**
     * Returns a new price with given discount applied
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.applyDiscount = function (price, discount) {
        if (!price) {
            return;
        }
        if (!discount || discount <= 0) {
            return price;
        }
        return price - price * (discount / 100);
    };
    /**
     * Initialize total value
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.initTotal = function () {
        var total = this.calculateTotal();
        this.displayedTotal = this.applyDiscount(total, this.model.discount);
        if (this.displayedTotal !== this.model.total) {
            console.warn("totals are different on init", this.displayedTotal, total);
        }
    };
    /**
     * Watch for value changes and update total value
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.updateTotal = function (value) {
        var _this = this;
        if (value !== this.previousValue) {
            this.previousValue = value;
            var detailControl = this.form.controls.detail;
            var discountControl = this.form.controls.discount;
            var currentDiscount_1 = discountControl.value;
            var total_1 = 0;
            if (detailControl) {
                detailControl.valueChanges.subscribe(function (res) {
                    total_1 = _this.calculateTotal();
                    _this.displayedTotal = _this.applyDiscount(total_1, currentDiscount_1);
                });
            }
            if (discountControl) {
                discountControl.valueChanges.subscribe(function (res) {
                    currentDiscount_1 = res;
                    _this.displayedTotal = _this.applyDiscount(total_1, currentDiscount_1);
                });
            }
        }
    };
    /**
     * Generate pdf with formatted balance data
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onGeneratePdf = function () {
        var _this = this;
        // Set balance notes
        var notes = [];
        if (this.notes) {
            this.notes.forEach(function (note) {
                // Date header
                notes.push({
                    text: moment(note.createdAt).format("DD/MM/YYYY hh:mm"),
                    style: "text",
                    margin: [0, 0, 0, 0],
                });
                // Text body
                notes.push({
                    text: note.text,
                    style: "text",
                    margin: [0, 0, 0, 10],
                });
            });
        }
        // Set pdf style macros
        var colWidths = ["*", 150, "*", "*", "*"];
        var fontSize = 10;
        var headerFontSize = fontSize + 5;
        var subHeaderFontSize = fontSize + 1;
        var tableHeaderFontSize = fontSize + 1;
        var tableColor = "#d8e4ec";
        var headingColor = "#a9d4f1";
        var balanceDetail = [];
        balanceDetail.push([
            "Codice",
            "Descrizione",
            "Quantità",
            "Prezzo unitario",
            "Totale riga",
        ]);
        if (this.balance.get("detail") && this.balance.get("detail").length) {
            var totScanIns_1 = 0;
            var totInsFollowing_1 = 0;
            var totScanFollowing_1 = 0;
            var scanIns_1 = false;
            this.balance.get("detail").forEach(function (el) {
                if (el.code == "MOD-DOC-DIG-A4" ||
                    el.code == "FILE-PDF" ||
                    el.code == "SC-PP" ||
                    el.code == "SC" ||
                    el.code == "MOD-DOC-CAR-A4" ||
                    el.code == "MOD-DOC-CAR-A3" ||
                    el.code == "MOD-DOC-CAR-A2" ||
                    el.code == "MOD-DOC-CAR-A1" ||
                    el.code == "MOD-DOC-CAR-A0" ||
                    el.code == "SC-FF") {
                    totScanIns_1 = totScanIns_1 + el.totalRow;
                    scanIns_1 = true;
                    if (el.code == "MOD-DOC-DIG-A4" || el.code == "FILE-PDF") {
                        totInsFollowing_1 = totInsFollowing_1 + el.totalRow;
                    }
                    if (el.code == "SC-PP" ||
                        el.code == "SC" ||
                        el.code == "MOD-DOC-CAR-A4" ||
                        el.code == "MOD-DOC-CAR-A3" ||
                        el.code == "MOD-DOC-CAR-A2" ||
                        el.code == "MOD-DOC-CAR-A1" ||
                        el.code == "MOD-DOC-CAR-A0" ||
                        el.code == "SC-FF") {
                        totScanFollowing_1 = totScanFollowing_1 + el.totalRow;
                    }
                }
                if (el.code === "UNIPACC001") {
                    el.description = _this.translateService.instant("companies.fields.subscription.housingUnits.title");
                    el.quantity = 1;
                    el.unitPrice = el.totalRow;
                }
                if (el.code === "BOXPACC001") {
                    el.description = _this.translateService.instant("companies.fields.subscription.boxUnits.title");
                    el.quantity = 1;
                    el.unitPrice = el.totalRow;
                }
            });
            // balanceDetail.push([
            //   "Codice",
            //   "Descrizione",
            //   "Quantità",
            //   "Prezzo unitario",
            //   "Totale riga",
            // ]);
            var balanceDetailRows = this.balance
                .get("detail")
                .filter(function (el) {
                return el.code !== "MOD-DOC-DIG-A4" &&
                    el.code !== "FILE-PDF" &&
                    el.code !== "SC-PP" &&
                    el.code !== "SC" &&
                    el.code !== "MOD-DOC-CAR-A4" &&
                    el.code !== "MOD-DOC-CAR-A3" &&
                    el.code !== "MOD-DOC-CAR-A2" &&
                    el.code !== "MOD-DOC-CAR-A1" &&
                    el.code !== "MOD-DOC-CAR-A0" &&
                    el.code !== "SC-FF";
            })
                .map(function (el) {
                return [
                    "" + el.code,
                    "" + el.description,
                    {
                        text: "" + el.quantity,
                        alignment: "right",
                    },
                    {
                        text: "\u20AC " + el.unitPrice.toFixed(2),
                        alignment: "right",
                    },
                    {
                        text: "\u20AC " + el.totalRow.toFixed(2),
                        alignment: "right",
                    },
                ];
            });
            balanceDetail = balanceDetail.concat(balanceDetailRows);
            if (scanIns_1) {
                if (this.subscription &&
                    (this.subscription.scanInsFirstCode ||
                        this.subscription.scanInsNextCode)) {
                    var code_1 = "";
                    var description = "";
                    if (this.isThisFirstBalance) {
                        code_1 = this.subscription.scanInsFirstCode;
                        var descriptionCode = this.configService.availableScanCodes.filter(function (element) {
                            return element.value === code_1;
                        });
                        if (descriptionCode &&
                            Array.isArray(descriptionCode) &&
                            descriptionCode.length) {
                            description = descriptionCode[0].description;
                            description = description.replace(/\s\s+/g, " ");
                            description = description.replace("#startDate#", moment(this.subscription.startDate).format("DD-MM-YYYY"));
                            description = description.replace("#endDate#", moment(this.subscription.endDate).format("DD-MM-YYYY"));
                        }
                        var rowScanIns = [
                            "" + code_1,
                            "" + description,
                            {
                                text: "1",
                                alignment: "right",
                            },
                            {
                                text: "\u20AC " + totScanIns_1.toFixed(2),
                                alignment: "right",
                            },
                            {
                                text: "\u20AC " + totScanIns_1.toFixed(2),
                                alignment: "right",
                            },
                        ];
                        balanceDetail.push(rowScanIns);
                    }
                    else {
                        // 4 - INSERIMENTI CARTACEI E DIGITALI SUCCESSIVI
                        if (this.subscription.scanInsNext) {
                            //  INSSUCC001
                            code_1 = this.subscription.scanInsNextCode;
                            var descriptionCode = this.configService.availableInsCodesNext.filter(function (element) {
                                return element.value === code_1;
                            });
                            if (descriptionCode &&
                                Array.isArray(descriptionCode) &&
                                descriptionCode.length) {
                                description = descriptionCode[0].description;
                                description = description.replace(/\s\s+/g, " ");
                            }
                            if (totInsFollowing_1 > 0) {
                                var rowScanIns = [
                                    "" + code_1,
                                    "" + description,
                                    {
                                        text: "1",
                                        alignment: "right",
                                    },
                                    {
                                        text: "\u20AC " + totInsFollowing_1.toFixed(2),
                                        alignment: "right",
                                    },
                                    {
                                        text: "\u20AC " + totInsFollowing_1.toFixed(2),
                                        alignment: "right",
                                    },
                                ];
                                balanceDetail.push(rowScanIns);
                            }
                        }
                        else if (this.subscription.flatRate) {
                            //  FINSSUCC001
                            code_1 = this.subscription.flatRateCode;
                            var descriptionCode = this.configService.availableInsCodesNextForfait.filter(function (element) {
                                return element.value === code_1;
                            });
                            if (descriptionCode &&
                                Array.isArray(descriptionCode) &&
                                descriptionCode.length) {
                                description = descriptionCode[0].description;
                                description = description.replace(/\s\s+/g, " ");
                            }
                            if (totInsFollowing_1 > 0) {
                                var rowScanIns = [
                                    "" + code_1,
                                    "" + description,
                                    {
                                        text: "1",
                                        alignment: "right",
                                    },
                                    {
                                        text: "\u20AC " + this.subscription.flatRateFee.toFixed(2),
                                        alignment: "right",
                                    },
                                    {
                                        text: "\u20AC " + this.subscription.flatRateFee.toFixed(2),
                                        alignment: "right",
                                    },
                                ];
                                balanceDetail.push(rowScanIns);
                            }
                        }
                        // 5 - SCANSIONI SUCCESSIVE
                        if (this.subscription.scanNext) {
                            //  SCASUCC001
                            code_1 = this.subscription.scanNextCode;
                            var descriptionCode = this.configService.availableScanCodesNext.filter(function (element) {
                                return element.value === code_1;
                            });
                            if (descriptionCode &&
                                Array.isArray(descriptionCode) &&
                                descriptionCode.length) {
                                description = descriptionCode[0].description;
                                description = description.replace(/\s\s+/g, " ");
                            }
                            if (totScanFollowing_1 > 0) {
                                var rowScanIns = [
                                    "" + code_1,
                                    "" + description,
                                    {
                                        text: "1",
                                        alignment: "right",
                                    },
                                    {
                                        text: "\u20AC " + totScanFollowing_1.toFixed(2),
                                        alignment: "right",
                                    },
                                    {
                                        text: "\u20AC " + totScanFollowing_1.toFixed(2),
                                        alignment: "right",
                                    },
                                ];
                                balanceDetail.push(rowScanIns);
                            }
                        }
                        else if (this.subscription.flatRateScan) {
                            //  FSCASUCC001
                            code_1 = this.subscription.flatRateScanCode;
                            var descriptionCode = this.configService.availableScanCodesNextForfait.filter(function (element) {
                                return element.value === code_1;
                            });
                            if (descriptionCode &&
                                Array.isArray(descriptionCode) &&
                                descriptionCode.length) {
                                description = descriptionCode[0].description;
                                description = description.replace(/\s\s+/g, " ");
                            }
                            if (totScanFollowing_1 > 0) {
                                var rowScanIns = [
                                    "" + code_1,
                                    "" + description,
                                    {
                                        text: "1",
                                        alignment: "right",
                                    },
                                    {
                                        text: "\u20AC " + this.subscription.flatRateScanFee.toFixed(2),
                                        alignment: "right",
                                    },
                                    {
                                        text: "\u20AC " + this.subscription.flatRateScanFee.toFixed(2),
                                        alignment: "right",
                                    },
                                ];
                                balanceDetail.push(rowScanIns);
                            }
                        }
                    }
                }
            }
        }
        var content = [];
        // Title
        content.push({
            text: "Riepilogo conto n. " + this.balance.get("number"),
            style: "header",
            margin: [0, 20, 0, 20],
        });
        // Balance
        content.push({
            text: "Numero conto: " + this.balance.get("number"),
            style: "subHeader",
            margin: [0, 0, 0, 8],
        });
        if (this.invoiceHolder === "property") {
            content.push({
                text: "Intestatario fattura: " + this.propertyName,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
            content.push({
                text: "Nome dell'immobile: " + this.propertyName,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
            content.push({
                text: "Codice fiscale: " + this.propertyTaxCode,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
            content.push({
                text: "Nome della societ\u00E0: " + this.companyName,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
        }
        if (this.invoiceHolder === "owner") {
            content.push({
                text: "Intestatario fattura: " + this.ownerName,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
            content.push({
                text: "Nome dell'immobile: " + this.propertyName,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
            content.push({
                text: this.ownerTaxCode !== ""
                    ? "Codice fiscale: " + this.ownerTaxCode
                    : "P.IVA: " + this.ownerVatNumber,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
            content.push({
                text: "Nome della societ\u00E0: " + this.ownerName,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
        }
        if (this.invoiceHolder === "admin") {
            content.push({
                text: "Intestatario fattura: " + this.companyName,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
            content.push({
                text: "Nome dell'immobile: " + this.propertyName,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
            content.push({
                text: this.companyTaxCode !== ""
                    ? "Codice fiscale: " + this.companyTaxCode
                    : "P.IVA: " + this.companyVatNumber,
                style: "subHeader",
                margin: [0, 0, 0, 8],
            });
        }
        content.push({
            text: "Inizio esercizio contabile: " + this.administrationStartDate,
            style: "subHeader",
            margin: [0, 0, 0, 8],
        });
        content.push({
            text: "Fine esercizio contabile: " + this.administrationEndDate,
            style: "subHeader",
            margin: [0, 0, 0, 8],
        });
        content.push({
            style: "table",
            table: {
                widths: colWidths,
                body: balanceDetail,
            },
            layout: {
                fillColor: function (rowIndex) {
                    return rowIndex % 2 === 0 ? tableColor : null;
                },
            },
        });
        content.push({
            style: "tableFooter",
            table: {
                widths: colWidths,
                body: [
                    [
                        "",
                        "",
                        "",
                        "SCONTO",
                        {
                            text: this.balance.get("discount") + "%",
                            alignment: "right",
                        },
                    ],
                    [
                        "",
                        "",
                        "",
                        "TOTALE FATTURA",
                        {
                            text: "\u20AC " + this.balance.get("total").toFixed(2),
                            alignment: "right",
                        },
                    ],
                ],
            },
            layout: {
                fillColor: headingColor,
            },
        });
        content.push({ text: "NOTE", style: "subHeader", margin: [0, 10, 0, 8] });
        var documentDefinition = {
            content: content.concat(notes),
            // [
            //   ...content,
            //   {
            //     style: "table",
            //     table: {
            //       widths: colWidths,
            //       body: balanceDetail,
            //     },
            //     layout: {
            //       fillColor: (rowIndex) => {
            //         return rowIndex % 2 === 0 ? tableColor : null;
            //       },
            //     },
            //   },
            //   {
            //     style: "tableFooter",
            //     table: {
            //       widths: colWidths,
            //       body: [
            //         [
            //           "",
            //           "",
            //           "",
            //           "SCONTO",
            //           {
            //             text: `${this.balance.get("discount")}%`,
            //             alignment: "right",
            //           },
            //         ],
            //         [
            //           "",
            //           "",
            //           "",
            //           "TOTALE FATTURA",
            //           {
            //             text: `€ ${this.balance.get("total").toFixed(2)}`,
            //             alignment: "right",
            //           },
            //         ],
            //       ],
            //     },
            //     layout: {
            //       fillColor: headingColor,
            //     },
            //   },
            //   // Notes
            //   { text: "NOTE", style: "subHeader", margin: [0, 10, 0, 8] },
            //   notes,
            // ],
            styles: {
                text: {
                    fontSize: fontSize,
                },
                header: {
                    fontSize: headerFontSize,
                    bold: true,
                    margin: [0, 0, 0, 0],
                    alignment: "center",
                },
                subHeader: {
                    fontSize: subHeaderFontSize,
                    bold: false,
                    margin: [0, 10, 0, 5],
                },
                table: {
                    fontSize: fontSize,
                    margin: [0, 0, 0, 0],
                },
                tableHeader: {
                    bold: true,
                    fontSize: tableHeaderFontSize,
                    color: "black",
                    margin: [0, 15, 0, 0],
                    alignment: "center",
                },
                tableFooter: {
                    bold: true,
                    fontSize: fontSize,
                    color: "black",
                    // color: '#dc3545',
                    margin: [0, 0, 0, 15],
                },
            },
        };
        pdfMake.createPdf(documentDefinition).open();
    };
    /**
     * Handle click to show document notes
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onViewDocumentNotes = function () {
        var notes = this.notes.map(function (note) {
            if (note.createdBy &&
                note.createdBy.firstName &&
                note.createdBy.lastName) {
                note.createdBy = tslib_1.__assign({}, note.createdBy, { name: note.createdBy.firstName + " " + note.createdBy.lastName });
                delete note.createdBy.firstName;
                delete note.createdBy.lastName;
            }
        });
        this.dialog.open(ViewNotesDialogComponent, {
            data: {
                modalTitle: this.translateService.instant("properties.documentsPage.noteList"),
                notes: this.notes,
                balanceId: this.balance.getId(),
            },
            minWidth: "50%",
        });
    };
    /**
     * Remove current user from database
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onDelete = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("dialogs.confirm.message"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.balancesService
                .delete(_this.balance.getId())
                .pipe(finalize(function () { return (_this.deleteBtnOptions.active = false); }))
                .subscribe(function (res2) {
                _this.toastrService.success(res2.message);
                // Once the user is deleted, redirect to list
                _this.router.navigate([_this.lang, "app", "balances", "list"]);
                return;
            }, function (err) {
                // Choose one of the following error handling
                // method. The first one shows a message right
                // under the form fields (if the form is properly
                // setted), the second one shows toastr
                // notifications for each error
                // this.helperService.handleFormError(this.passwordForm, err);
                _this.helperService.handleError(err);
            }));
        });
    };
    /**
     * Load requested data page
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.loadInvoicesPage = function () {
        var start = this.paginator.pageIndex * this.paginator.pageSize;
        var length = this.paginator.pageSize;
        var search = {
            general: "",
            number: this.numberFilter.value,
            date: this.dateFilter.value
                ? new Date(this.dateFilter.value).toISOString()
                : undefined,
            file: this.fileFilter.value,
            balanceNumber: this.balanceNumber,
        };
        this.dataSource.loadItems(start, length, this.sort.active, this.sort.direction, search);
    };
    /**
     * Reset table's filters
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onResetInvoicesFilters = function () {
        // Reset lists service data
        this.listsService.setListSetting("invoices", 0, 10, {});
        // Reset tables' filters
        // this.input.nativeElement.value = '';
        this.numberFilter.setValue(null);
        this.dateFilter.setValue(null);
        this.fileFilter.setValue(null);
        // Reset tables' sorting versus and column
        this.sort.direction = "desc";
        this.sort.active = "number";
        this.sort._stateChanges.next();
        // Reset paginator
        this.paginator.pageIndex = 0;
        this.paginator.pageSize = 10;
        // Reload table's data
        this.loadInvoicesPage();
    };
    /**
     * Reset given filter value and reload the page
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onResetInvoicesFilter = function (filter) {
        filter.reset();
        this.loadInvoicesPage();
    };
    /**
     * Export invoices in a file with given format
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onInvoiceExport = function () {
        var _this = this;
        var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
        var fileName = this.translateService.instant("invoices.exportFileName") + " " + date;
        this.subscriptions.push(this.invoicesService.getExport(this.balanceNumber).subscribe(function (res) {
            var fileBlob = res;
            var blob = new Blob([fileBlob], {
                type: "application/vnd.ms-excel",
            });
            FileSaver.saveAs(blob, fileName + ".xlsx");
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Add new invoice
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onNewInvoice = function () {
        var _this = this;
        var dialogRef = this.dialog.open(AddInvoiceDialogComponent, {
            data: {
                balanceNumber: this.balance.get("number"),
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            _this.loadInvoicesPage();
            // if (!res) {
            //   return;
            // } else {
            //   this.loadInvoicesPage();
            // }
        });
    };
    /**
     * Edit invoice
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onEditInvoice = function (invoice) {
        var _this = this;
        var dialogRef = this.dialog.open(EditInvoiceDialogComponent, {
            data: {
                balanceNumber: this.balance.get("number"),
                invoiceId: invoice._id,
                number: invoice.number,
                date: invoice.date,
                file: invoice.file,
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            _this.loadInvoicesPage();
            // if (!res) {
            //   return;
            // } else {
            //   this.loadInvoicesPage();
            // }
        });
    };
    /**
     * Delete invoice
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onDeleteInvoice = function (invoiceId) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.invoice.title"),
                message: this.translateService.instant("dialogs.invoice.message"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.close"),
            },
            width: "500px",
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res) {
                _this.subscriptions.push(_this.invoicesService.delete(invoiceId).subscribe(function (res) {
                    if (res.status) {
                        _this.loadInvoicesPage();
                    }
                }, function (err) {
                    // if we came here users with given userId do not exist
                    _this.helperService.handleError(err);
                }));
            }
        });
        return;
    };
    /**
     * Handle click to show balance details
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onViewDetails = function () {
        this.dialog.open(BalanceViewDetailDialogComponent, {
            data: {
                modalTitle: this.translateService.instant("balances.showDetail"),
                detail: this.balance.get("detailCopy"),
            },
            width: "80%",
        });
    };
    /**
     * Handle click to print balance details
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onPrintDetails = function () {
        this.dialog.open(BalancePrintDetailDialogComponent, {
            data: {
                modalTitle: this.translateService.instant("balances.printDetail"),
                detail: this.balance.get("detailCopy"),
            },
            width: "80%",
        });
    };
    /**
     * Handle edit
     *
     * @since 1.0.0
     */
    BalanceDetailComponent.prototype.onEdit = function (text, noteId) {
        var _this = this;
        var editDialogRef = this.dialog.open(BalanceEditNoteDialogComponent, {
            minWidth: "40%",
            maxHeight: "98vh",
            data: {
                title: this.translateService.instant("properties.structures.notes"),
                text: text,
                balanceId: this.balance.getId(),
                noteId: noteId,
            },
            disableClose: true,
        });
        editDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res || !(res.status === true || res.success === true)) {
                return;
            }
            // The updated text may be returned at the top level (`text`) or wrapped
            // under `data` depending on the API version; read it defensively.
            var updatedText = res.text !== undefined && res.text !== null
                ? res.text
                : res.data && res.data.text;
            var index = _this.notes.findIndex(function (el) {
                return (el._id.toString() === noteId.toString());
            });
            if (index > -1 && updatedText !== undefined && updatedText !== null) {
                _this.notes[index].text = updatedText;
            }
            return;
        });
    };
    /**
    * Handle delete
    *
    * @since 1.0.0
    */
    BalanceDetailComponent.prototype.onDeleteNote = function (noteId) {
        var _this = this;
        var confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
            minWidth: "30%",
            maxHeight: "98vh",
            data: {
                title: this.translateService.instant("common.warnings.warning"),
                message: this.translateService.instant("common.warnings.noteDelete"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        confirmDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.balancesService
                .deleteNote(_this.balance.getId(), noteId)
                .pipe(take(1))
                .subscribe(function (res) {
                if (res.status) {
                    _this.toastrService.success(res.message);
                    var index = _this.notes.findIndex(function (el) {
                        return (el._id.toString() === noteId.toString());
                    });
                    if (index > -1) {
                        _this.notes.splice(index, 1);
                    }
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
            }));
            return;
        });
    };
    return BalanceDetailComponent;
}());
export { BalanceDetailComponent };
